import BasicLayout from '../layouts/BasicLayout';
import NotFoundPage from '../pages/NotFoundPage';

const NotFoundRoute = () => (
    <BasicLayout>
        <NotFoundPage />
    </BasicLayout>
);

export default NotFoundRoute;
